module.exports = __webpack_public_path__ + "static/img/103081.095dab18.png";